import React, { ReactNode } from 'react';
import { MenuItem } from 'react-pro-sidebar';
import { AbsoluteNavLink } from '@/components/AbsoluteNavLink';

export interface SideBarElementItemProps {
  to?: string;
  onClick?: () => void;
  shouldShow: boolean;
  children: ReactNode;
  end?: boolean;
  icon?: ReactNode;
  'aria-label'?: string;
  'aria-roledescription'?: string;
  'data-cy'?: string;
  id?: string;
}

const SideBarElement = ({
  children,
  onClick,
  icon,
  shouldShow,
  to,
  'aria-label': ariaLabel,
  'aria-roledescription': ariaRoleDescription,
  id,
  'data-cy': dataCy,
  ...props
}: SideBarElementItemProps) => {
  const className =
    'flex flex-row gap-x-3 items-center [&.active]:font-bold [&.active]:bg-blue-light/20 font-light';

  if (!shouldShow) return null;

  if (to) {
    return (
      <div id={id} {...props}>
        <MenuItem
          // @ts-ignore
          component={<AbsoluteNavLink end to={to} className={className} />}
          onClick={onClick}
          icon={icon}
          title={id}
          data-cy={dataCy}
          aria-label={ariaLabel}
          aria-roledescription={ariaRoleDescription}
          className="m-0 active:text-blue-light"
        >
          {children}
        </MenuItem>
      </div>
    );
  }

  return (
    <div data-cy={dataCy} className={className} {...props}>
      <MenuItem
        role="button"
        aria-label={ariaLabel}
        aria-roledescription={ariaRoleDescription}
        className="m-0 active:text-blue-light"
        onClick={onClick}
        title={id}
        icon={icon}
        component={<div className={className}>{children}</div>}
      >
        {children}
      </MenuItem>
    </div>
  );
};

export default SideBarElement;
